export default __webpack_public_path__ + "static/media/step_E_EN.d706e887.png";